import { render, staticRenderFns } from "./ActionDowngradeAnbietenTask.vue?vue&type=template&id=1cddd4f8&scoped=true&"
import script from "./ActionDowngradeAnbietenTask.vue?vue&type=script&lang=js&"
export * from "./ActionDowngradeAnbietenTask.vue?vue&type=script&lang=js&"
import style0 from "./ActionDowngradeAnbietenTask.vue?vue&type=style&index=0&id=1cddd4f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddd4f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VDialog,VSpacer,VTooltip})
